import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/Login';
import MainPage from './pages/MainPage';
import AdminPage from './pages/AdminPage';
import AliasPage from './pages/AliasPage';
import LogoPage from './pages/LogoPage';
import TeamAliasPage from './pages/TeamAliasPage';
import ColorConfigPage from './pages/ColorConfigPage';
import RoleConfigPage from './pages/RoleConfigPage';
import './styles.scss';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { NotificationSystem } from './components/NotificationSystem';

function App() {
    return (
        <AuthProvider>
            <ToastContainer />
            <NotificationSystem />
            <Router>
                <Routes>
                    <Route path="/" element={<Login />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/home" element={<MainPage key={window.location.pathname} />} />
                    <Route path="/admin" element={<AdminPage />} />
                    <Route path="/logos" element={<LogoPage />} />
                    <Route path="/alias" element={<AliasPage />} />
                    <Route path="/teamalias" element={<TeamAliasPage />} />
                    <Route path="/colorconfig" element={<ColorConfigPage />} />
                    <Route path="/roleconfig" element={<RoleConfigPage />} />
                </Routes>
            </Router>
        </AuthProvider>

    );
}

export default App;
